import React, { useEffect, useState } from "react";
import { DndContext, DragOverlay, pointerWithin, MouseSensor, TouchSensor, useSensor, useSensors } from "@dnd-kit/core";
import { snapCenterToCursor } from '@dnd-kit/modifiers';
import { observer } from 'mobx-react-lite';

import classes from "./Selection.module.css";
import ScaleManager from "react-sdk/ScaleManager";
import AppState, { SCREENS } from "@/js/AppState";
import { FaArrowRight, FaStar } from "react-icons/fa6";
import { RiCoinLine } from "react-icons/ri";
import Texts from "react-sdk/Texts";
import Block from "./component/Block/Block";
import DroppableArea from "./component/DroppableArea/DroppableArea";
import Item from "./component/Item/Item";
import Button from "../shared/Button/Button";
import FtueHelper from "@/js/FtueHelper";


function scaleModifier(args) {

  const { transform, } = args;

  return {
    ...transform,
    x: (transform.x / ScaleManager.scale) + (ScaleManager.marginPos === "left" ? ScaleManager.margin : 0),
    y: (transform.y / ScaleManager.scale) - (ScaleManager.marginPos === "top" ? ScaleManager.margin : 0)
  }
}

const Selection = ({ }) => {
  const [step, setStep] = useState(0);

  useEffect(() => {
    setStep(0)
  }, [])

  const handleDragStart = (event) => {
    const draggedItem = AppState.selection.blocks
      .flatMap((block) => block.items)
      .find((item) => item.id === event.active.id);

    AppState.selection.activeItem = draggedItem;
  };

  const handleDragEnd = (event) => {
    if (event.over && event.over.id === "dock") {
      let i = AppState.selection.getItem(event.active.id)
      if (getPoints() - i.cost >= 0) {
        AppState.selection.itemSelected.push(i);

        if (!FtueHelper.hasShownFtue("demain_03")) {
          FtueHelper.openFtues(["demain_03"], "map", true)
        }
      }
    }

    // if (points - AppState.selection.getItem(event.active.id).cost >= 0)
    // setSelectedItems([...selectedItems, event.active.id]); // TEMP : Select item because DD is not working

    AppState.selection.activeItem = null; // Clear active item after dropping
  };

  const OnPopupValidate = () => {

    // setStep(STEPS.VALIDATE)
  }

  const onValidateClick = () => {
    AppState.dials.playSequence("Dials", "outro", () => {
      AppState.setScreen(SCREENS.ECRAN_FINAL)
    })
  }

  const OnCompleteSelectionClick = () => {
    AppState.setScreen(SCREENS.ECRAN_FINAL)
  }

  const mouseSensor = useSensor(MouseSensor, {
    activationConstraint: { distance: 30 }
  });
  const touchSensor = useSensor(TouchSensor, {
    activationConstraint: { distance: 30 }
  });
  const sensors = useSensors(
    mouseSensor,
    touchSensor
  );

  const getPoints = () => {
    if (AppState.selection) {
      var points = AppState.selection.points

      AppState.selection.itemSelected.forEach(item => {
        points -= item.cost
      })

      return points
    }
    return 0
  }

  const getLowestRemainingCost = () => {
    if (!AppState.selection) return 0

    let points = AppState.selection.basePoints * 2 // juste pour être sur d'être plus haut que le plus couteux
    AppState.selection.blocks.map(b => b.items).flat().forEach(item => {
      if (!item.selected && item.cost < points)
        points = item.cost
    })

    if (getPoints() < points && !FtueHelper.hasShownFtue("demain_05")) {
      FtueHelper.openFtues(["demain_05"], "map", true)
    }

    return points
  }

  const removeItem = (item) => {

    AppState.selection.itemSelected.remove(item)

    if (!FtueHelper.hasShownFtue("demain_04")) {
      FtueHelper.openFtues(["demain_04"], "map", true)
    }
  }

  if (!AppState.selection) return null

  return (
    <div className={`${classes.Selection} ${step >= 3 ? classes.Summary : ""}`}>
      <DndContext onDragStart={handleDragStart}
        onDragEnd={handleDragEnd}
        collisionDetection={pointerWithin}
        sensors={sensors}
      >
        <div className={classes.Points}>{getPoints()}<RiCoinLine /></div>
        
        <div className={classes.title}>{ Texts.get("selection-title") }</div>

        <div className={classes.SelectedItemsContainer}>

          {AppState.selection.itemSelected.map((item, index) =>
            <Item key={`selected_${item.id}`} item={item} removeItem={removeItem} />)}

          {getPoints() > 0 &&
            <div className={classes.dropAreaCtnr}>
              <DroppableArea active={AppState.selection.activeItem !== null} />
              {Texts.get("selection-drop-zone-text")}
            </div>}
        </div>

        {getPoints() < getLowestRemainingCost() &&
          <Button className={classes.ValidateBtn} onClick={() => onValidateClick()}>
            <div className={classes.ValidateBtnText}>
              {Texts.get("selection-validate-btn")} <FaArrowRight />
            </div>
          </Button>
        }

        {AppState.selection &&
          <div className={classes.BlockContainer}>
            <div className={classes.BlockList} >
              {AppState.selection.blocks.map((block, index) =>
                <Block key={`Block${index}`} index={index} block={block} />
              )}
            </div>
          </div>}

        {/* {
              AppState.selection.activeItem && <div className={`${classes.DropZone} ${AppState.selection.activeItem ? classes.DropZoneActive : ""}`} >
                <DroppableArea active={AppState.selection.activeItem !== null} />
              </div>
            } */}


        <DragOverlay modifiers={[snapCenterToCursor, scaleModifier]}>
          {AppState.selection.activeItem &&
            <Item item={AppState.selection.activeItem} />}
        </DragOverlay>

        {step === 1 &&
          <div className={classes.PopupSelectionCompleted}>
            <div className={classes.PopupSelectionCompletedContent}>
              <h1>{Texts.get("AppState.selection-popup-completed-title")}</h1>
              <p>{Texts.get("AppState.selection-popup-completed-description")}</p>
              <button className={classes.BtnValidate} onClick={() => OnPopupValidate()}>{Texts.get("AppState.selection-popup-completed-button")}</button>
            </div>
          </div>}

      </DndContext>
    </div>
  );
};

export default observer(Selection);